import { LoanProduct } from 'app/models/dto/loan-product.model';

export class QueueDealsForDecisioning {
  static readonly type = '[Decisioning] QueueDealsForDecisioning';
  constructor(
    public borrowerId: number,
    public loanProducts: LoanProduct[]
  ) {}
}

export class QueueBorrowerDecisioning {
    static readonly type = '[Decisioning] QueueBorrowerDecisioning';
    constructor(
      public borrowerId: number,
      public loanProduct: any,
    ) {}
  }